
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class HowXt extends Vue {
  status: 'init' | 'play' | 'pause' = 'init'

  @Ref()
  howXtVideo: {
    handlePlay: () => void
  } | null

  get options() {
    return {
      video: {
        url: 'https://testing-static.xuantong.cn/video/tenth-yearv3.m4v',
        pic: 'https://file.xuantong.cn/images/origin/ce5015534a6868be50ac11d3383929a7.png'
      },
      screenshot: false,
      lang: 'zh-cn',
      autoplay: false
    }
  }

  onPause() {
    this.status = 'pause'
  }

  onPlay() {
    if (!this.howXtVideo) return

    this.howXtVideo.handlePlay()
    this.status = 'play'
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
